import React, { useEffect, useState } from 'react';
import axios from 'axios';

function DocumentsTab({ caseId }) {
  const [documents, setDocuments] = useState([]);

  const fetchDocuments = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/projectdocument/by-project/${caseId}`);
      setDocuments(res.data);
    } catch (error) {
      console.error('Error fetching project documents:', error);
    }
  };

  useEffect(() => {
    if (caseId) fetchDocuments();
  }, [caseId]);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {documents.map((doc) => (
          <div key={doc._id} className="bg-white p-4 border rounded shadow">
            <h3 className="font-bold text-lg">{doc.originalName}</h3>
            <p>Type: {doc.fileType}</p>
            <p>Size: {Math.round(doc.fileSize / 1024)} KB</p>
            {/* <a
              href={`${process.env.REACT_APP_BACKEND_URL}/api/projectdocument/view/${doc.filename}`}
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 underline mt-2 inline-block"
            >
              View Document
            </a> */}
            <a
              href={`${process.env.REACT_APP_BACKEND_URL}/api/projectdocument/download/${doc.filename}`}
              className="text-green-600 underline ml-4"
            >
              Download
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DocumentsTab;
